import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Grid,
  styled
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';

const AccordionStyled = styled(Accordion)`
  border-radius: 30px;
  border: solid;
  box-shadow: none;
  margin-top: 10px;
  &.MuiAccordion-root:before {
    display: none;
  }
  &.MuiAccordion-root:first-of-type {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }
  &.MuiAccordion-root:last-of-type {
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
`;

const RcWarrantyAccordion = () => {
  const { t } = useTranslation('rc');
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (_: any, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const garantiesKeys = ['1', '2', '3', '4'];

  return (
    <Grid container justifyContent="center" alignItems="center" spacing={2} mt={2}>
      <Grid item xs={12} sx={{ mb: 2 }} textAlign="center">
        <Typography variant="h4" sx={{ textTransform: 'uppercase' }}>
          {t('step3.warranties_title')}
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ mb: 2 }}>
        {garantiesKeys.map((key) => (
          <AccordionStyled key={key} expanded={expanded === key} onChange={handleChange(key)}>
            <AccordionSummary
              sx={{ boxShadow: 'none' }}
              expandIcon={null}
              aria-controls={`panel${key}-content`}
              id={`panel${key}-header`}
            >
              <Box
                mr={2}
                sx={{
                  transform: expanded === key ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              >
                <ExpandMoreIcon />
              </Box>
              <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                <Typography variant="h5">{t(`step3.warranties.details.${key}.title`)}</Typography>
                <CheckCircleIcon color="success" />
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                {t(`step3.warranties.details.${key}.description`)}
              </Typography>
            </AccordionDetails>
          </AccordionStyled>
        ))}
      </Grid>
    </Grid>
  );
};

export default RcWarrantyAccordion;
